import React, { FC } from "react";
import { ITableFilter } from "../../../common/interfaces/user-dashboard.interface";
import TableFilterItem from "../DashboardTable/TableFilterItem/TableFilterItem";
import "./TableTitleAndFilters.scss";
const TableTitleAndFilters: FC<{
  tableTitle: string;
  filtersData: ITableFilter[];
}> = ({ tableTitle, filtersData }) => {
  return (
    <div className="table-title-filters">
      <p>{tableTitle}</p>
      <div className="table-title-filters__filters">
        {filtersData.map((filterData) => {
          return (
            <TableFilterItem
              onFilterItemSelect={filterData.onFilterSelect}
              title={filterData.filterTitle}
              amount={filterData.filterAmount}
              key={filterData.filterTitle}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TableTitleAndFilters;
